module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "images/img-9-1.jpg",
      "src": "images/img-9-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ct2",
    attrs: {
      "id": "pz13-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#aa_03",
      "id": "bb_03"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "ct3"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#aa_03"
    }
  }, [_c('b', [_vm._v("PANIC, PROVIDENCE, AND THE PASTOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz13-10"
    }
  }, [_vm._v("I thought I was going insane.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-11"
    }
  }, [_vm._v("My brain felt as though it were splitting in half.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-12"
    }
  }, [_vm._v("I struggled just to breathe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-13"
    }
  }, [_vm._v("My mind raced, and my thoughts were jumbled and murky.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-14"
    }
  }, [_vm._v("I couldn’t talk with anyone; dealing with people was virtually impossible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-15"
    }
  }, [_vm._v("I felt I couldn’t worship or even pray.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-16"
    }
  }, [_vm._v("The peace of God seemed a million miles away, totally out of my reach.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-17"
    }
  }, [_vm._v("Life was excruciating and my fears so incredibly debilitating.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "AHx"
    }
  }, [_vm._v("A person can take only so much.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-18"
    }
  }, [_vm._v("I’m a Christian. I love Jesus. In fact, I’m a pastor of a large church where—week in and week out—I teach thousands of people the truths of God. I believe in His grace, healing, and powers of deliverance. I believe He loves me and wants the absolute best for my life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-6"
    }
  }, [_vm._v("But on an all-too-frequent basis, I suffer greatly from panic disorder. Overwhelming fear grips my soul and won’t let up—for hours, sometimes days, even weeks. I totally get David’s dark language often used throughout Psalms, in passages such as this one:"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("My heart is in anguish within me; "), _c('br'), _vm._v("the terrors of death have fallen on me.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Fear and trembling have beset me; "), _c('br'), _vm._v("horror has overwhelmed me.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I said, “Oh, that I had the wings of a dove! "), _c('br'), _vm._v("I would fly away and be at rest.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I would flee far away "), _c('br'), _vm._v("and stay in the desert;")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I would hurry to my place of shelter, "), _c('br'), _vm._v("far from the tempest and storm. (Ps. 55:4–8 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIV")]), _vm._v(")"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-17"
    }
  }, [_vm._v("While the psalmist likely wasn’t describing a panic attack, the bottom line is that he was suffering—suffering at a level he wanted to run from but couldn’t escape because the enemy he was battling the most was inside his own soul.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-18"
    }
  }, [_vm._v("In the pages of this book, I want to share my story with you—a tale of salvation, redemption, and favor, coupled with the reality of my ongoing battle with an often-debilitating medical condition that began at age six.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-19"
    }
  }, [_vm._v("A prevailing belief in our Western church culture is that God will keep bad things from happening to good people, especially His people. But according to Scripture—regardless of which theological circles we belong to—this man-made paradigm is not true. It never was and never will be. We’ve seen, "), _c('span', {
    attrs: {
      "id": "z15-6"
    }
  }, [_vm._v("heard, and experienced too many bad things happening to good people—even to Christians, even to us—too many times. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-7"
    }
  }, [_vm._v("In fact, much of life feels like a battle. Maybe that’s why my struggle with panic and fear has, for so many years, produced a huge measure of doubt, questioning, and even feelings of abandonment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-8"
    }
  }, [_vm._v("Perhaps you have been diagnosed with panic disorder, experience panic attacks, or at the very least feel as though you wrestle with fear more than the average person does. Maybe the phrase “freaking out” in the book’s subtitle caught your eye, and you feel those words describe how you live more often than you want to admit. Or maybe you picked up this book because your spouse, child, parent, relative, or friend suffers from this condition and you want to better understand how to sympathize with, minister to, and love on that person. May God bless you for caring on such a deep level. I hope you find clarity and encouragement here to help your loved one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-9"
    }
  }, [_vm._v("Regardless, I pray you find comfort, community, and counsel in these pages.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-10"
    }
  }, [_vm._v("Now that straight out of the gate you have a good understanding of my faith in God, my pastoral credentials, and my level of panic and fear, I want to make one thing crystal clear to those of you who are suffering in fear: "), _c('i', [_vm._v("I know how you feel")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-11"
    }
  }, [_vm._v("This statement of empathy is so important to me to get across to you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-12"
    }
  }, [_c('i', [_vm._v("I know how you feel")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-13"
    }
  }, [_vm._v("You might not believe anyone could possibly understand, but I do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-14"
    }
  }, [_vm._v("As a matter of fact—and to be completely transparent—the main reason I wrote this book was to say those five words "), _c('span', {
    attrs: {
      "id": "z16-6"
    }
  }, [_vm._v("to those who suffer from fear. Why else would I want to confess the worst part of my life and some of my most embarrassing moments when, as a pastor of a large congregation and member of an awesome family, I could have written about my blessings—all the feel-good stuff many pastors have written about successfully? ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-7"
    }
  }, [_vm._v("In the land of anxiety and panic, not many people are willing to talk openly and candidly—especially in the church—so I will. Sure, we’d all rather hide behind an “I’m fine” in the church hallway than confess the truth: “I’m hurting.” But I want to change that. For you. Here and now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-8"
    }
  }, [_vm._v("For those of us who have panic attacks, on our best days we’re physically miserable; on our worst days, we feel like sub-par Christians. If the Bible says we need not be anxious, then why are we? If Jesus is our solid Rock and Fortress, then why do we feel as if we’re living on sand in isolation? If Jesus can calm the wind and waves, why can’t He calm the tempest in our hearts? And for goodness’ sake, why doesn’t He take the fear away? Just deliver us, heal us?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-9"
    }
  }, [_vm._v("Decade after decade I’ve asked these questions. You probably have too. I’ve tried everything, followed almost every recommendation, and yet here I am, still a broken man—successful and strong by the world’s standards but often feeling like a scared child within. I influence the lives of thousands upon thousands but can’t eliminate panic attacks in my own life. Recognized and respected preachers have told me I’m not “accessing the kingdom,” or I “don’t have enough faith,” or I haven’t “really read the Word,” but by the very token that they would say such things, I know they’ve never faced what I have. The fact remains: I "), _c('i', [_vm._v("know")]), _vm._v(" I am a child of God—and I’m "), _c('i', [_vm._v("still")]), _vm._v(" scared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-6"
    }
  }, [_vm._v("My hope is that five things will happen in your own heart as you read:"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "pz17-7"
    }
  }, [_vm._v("1. You will be overwhelmed by the presence of God and come to believe He is with you on your journey.")]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "pz17-8"
    }
  }, [_vm._v("2. You will be deeply encouraged that there are millions of your brothers and sisters walking alongside you, with you, supporting you.")]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "pz17-9"
    }
  }, [_vm._v("3. You will experience a freedom to realize your fear does not have to "), _c('i', [_vm._v("define")]), _vm._v(" you nor "), _c('i', [_vm._v("confine")]), _vm._v(" you.")]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "pz17-10"
    }
  }, [_vm._v("4. You will not merely "), _c('i', [_vm._v("survive")]), _vm._v(" life with anxiety but learn to "), _c('i', [_vm._v("thrive")]), _vm._v(" in and through the storms.")]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "pz17-11"
    }
  }, [_vm._v("5. You will learn how to truly live, even in fear, because there is so much life God has for you to embrace, even in the midst of your struggle."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-12"
    }
  }, [_vm._v("My personal goals for this book are to"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ol",
    attrs: {
      "id": "pz17-13"
    }
  }, [_vm._v("1. Provide help for the hurting, while making no guarantees.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_vm._v("Since he himself has gone through suffering and testing, he is able to help us when we are being tested. (Heb. 2:18 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NLT")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-15"
    }
  }, [_vm._v("I wish I could say that if you read this book you will no longer suffer from anxiety. I can’t make that promise. But, as evidenced in my own life, I do think you will find divine help "), _c('i', [_vm._v("in")]), _vm._v(" your suffering, not a personal cure "), _c('i', [_vm._v("from")]), _vm._v(" your suffering. I’ve read plenty of books that make promises for healing, only to find that not only does the author "), _c('i', [_vm._v("not")]), _vm._v(" suffer from fear, anxiety, "), _c('span', {
    attrs: {
      "id": "z18-6"
    }
  }, [_vm._v("or panic attacks but he or she doesn’t even "), _c('i', [_vm._v("understand")]), _vm._v(" the condition. I do suffer; I do understand; I want to encourage you by sharing my story, along with everything that has helped me. ")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ol"
  }, [_vm._v("2. Shut down the bullies."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Live, G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OD")]), _vm._v("! Blessings from my Rock, "), _c('br'), _vm._v("my free and freeing God, towering!")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("This God set things right for me "), _c('br'), _vm._v("and shut up the people who talked back.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("He rescued me from enemy anger, "), _c('br'), _vm._v("he pulled me from the grip of upstarts,")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("He saved me from the bullies. (Ps. 18:46–48 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE MESSAGE")]), _vm._v(")"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-15"
    }
  }, [_vm._v("Growing up in the church culture, I have had far too much interaction with sharp-tongued, religious bruisers who declare if you struggle then somehow you are a weak Christian. If this is true, what do you do with the words of David and others in Scripture who vocally battled invisible enemies on an emotional, mental, and spiritual level? And why would God decide to place those cries and confessions right smack in the middle of His Book?"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ol"
  }, [_vm._v("3. Bring hope to your heart.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_vm._v("You, too, must be patient. Take courage, for the coming of the Lord is near. (James 5:8 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NLT")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-19"
    }
  }, [_vm._v("Take courage, my friend. You are not alone. God has not abandoned you. He is walking with you. Your suffering "), _c('span', {
    attrs: {
      "id": "z19-1"
    }
  }, [_vm._v("doesn’t mean you aren’t saved. You are gloriously adopted as God’s child. You are not the only one who doubts and hurts. We are all on different journeys, but together, no matter how dark and long the tunnel might get, we can behold the beautiful bright Light at the end and run to Him. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-2"
    }
  }, [_vm._v("In fact, I invite you now to run with me. Let’s do this! Let me share with you what I’ve learned about how to live in fear and mastering the art of freaking out.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba7292e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter03.vue
// module id = 78
// module chunks = 0